import {connect} from '../../app/connect';
import IssueCreateForm from './IssueCreateForm';
import {
  getCurrentUserId,
  getCurrentProject,
  getAnalyticsId,
  getOxygenMappings,
  getPendingIssue,
  getPendingIssueForm,
  getCurrentSheets,
  getActiveUsers,
  getGroupedProjectActiveEntities,
  getUploadingAttachments,
  isUploadingAttachments,
  getPendingIssueFormAttributes,
  getIssueTypesAdminEntitiesMap,
  getIsCreateFormDeepLinking,
  getIssueAttributesMappingEntitiesMap,
  getIssueAttributesDefinitionsEntitiesMap,
  getFieldIssueTypesAndSubTypesIdToTitleMap,
  getActiveFieldIssueTypes,
  getActiveFieldIssueSubTypes,
  getActiveIssueRootCausesGroupedDropdownOptions,
  getIssueRootCausesDefinitionsEntitiesMap,
  getDefaultIssueSubtypeId,
  getActiveTemplatesOrderedIds,
  getRequiredFieldsFormatted,
  getCurrentViewType,
  getLocationsTreeNodesDictionary
} from '../../app/selectors';
import {attachmentOrigin} from '../../constants/attachments';
import featureFlags, {FEATURE_FLAGS} from '../../utils/featureFlags';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import {getFormValuesFromTemplate} from '../../app/templates/template-selectors';

const mapStateToProps = (state, ownProps) => {
  const pendingIssue = getPendingIssue(state);
  const requiredFieldsMap = getRequiredFieldsFormatted(state);
  if (ownProps.titleFieldRequired === false || ownProps.titleFieldRequired === true) {
    requiredFieldsMap[ISSUE_ATTRIBUTE_NAMES.TITLE] = ownProps.titleFieldRequired;
  }

  return {
    pendingIssue,
    pendingIssueForm: getPendingIssueForm(state),
    pendingIssueFormAttributes: getPendingIssueFormAttributes(state),
    oxygen: getOxygenMappings(state),
    currentUserId: getCurrentUserId(state),
    currentProject: getCurrentProject(state),
    analyticsId: getAnalyticsId(state),
    disabled: ownProps.disabled,
    focusForm: ownProps.focusForm,
    onSaveStart: ownProps.onSaveStart,
    onSaveSuccess: ownProps.onSaveSuccess,
    onSaveError: ownProps.onSaveError,
    handleSave: ownProps.handleSave,
    issuePushpin: ownProps.issuePushpin,
    document: ownProps.document,
    targetUrn: ownProps.targetUrn,
    additionalAttributes: ownProps.additionalAttributes,
    initialFieldValues: ownProps.initialFieldValues,
    availableStatuses: ownProps.availableStatuses,
    currentSheet: getCurrentSheets(state).length ? getCurrentSheets(state)[0] : null,
    fieldIssueTypeEntitiesMap: getIssueTypesAdminEntitiesMap(state),
    fieldIssueTypes: getActiveFieldIssueTypes(state),
    fieldIssueSubTypes: getActiveFieldIssueSubTypes(state),
    users: getActiveUsers(state),
    groupedProjectEntities: getGroupedProjectActiveEntities(state),
    uploadingAttachments: getUploadingAttachments(state),
    isUploadingAttachments: isUploadingAttachments(state, attachmentOrigin.CREATE_FORM),
    issueCustomAttributesMappings: getIssueAttributesMappingEntitiesMap(state),
    issueCustomAttributes: getIssueAttributesDefinitionsEntitiesMap(state),
    activeIssueRootCausesGroupedDropdownOptions: getActiveIssueRootCausesGroupedDropdownOptions(state),
    rootCauseEntitiesMap: getIssueRootCausesDefinitionsEntitiesMap(state),
    isCreateFormDeepLinking: getIsCreateFormDeepLinking(state),
    issueTypesAndSubTypesTitleMap: getFieldIssueTypesAndSubTypesIdToTitleMap(state),
    isDateSelectorMigrationEnabled: featureFlags.get(FEATURE_FLAGS.DATE_SELECTOR),
    systemDefaultIssueSubtypeId: getDefaultIssueSubtypeId(state),
    formValuesFromTemplate: getFormValuesFromTemplate(state, pendingIssue[ISSUE_ATTRIBUTE_NAMES.TEMPLATE_ID]),
    anyActiveIssueTemplates: getActiveTemplatesOrderedIds(state).length > 0,
    requiredFieldsMap,
    viewType: getCurrentViewType(state),
    locationsTreeNodesDictionary: getLocationsTreeNodesDictionary(state),
    updateDocumentDetails: featureFlags.get(FEATURE_FLAGS.UPDATE_DOCUMENT_DETAILS_IN_CREATE_ISSUE)
  };
};

export default connect(
  mapStateToProps,
  undefined,
  undefined,
  {forwardRef: true}
)(IssueCreateForm);
